module.exports = __webpack_public_path__ + "img/146.f73df7a2.png";